import { BaseTracker } from '../models'

export function isTrackerPrivate(tracker: {
  permissionPreset: BaseTracker['permissionPreset']
}): boolean {
  return tracker.permissionPreset === 'Private'
}

export default isTrackerPrivate
